import { INNER_PAGE_HEIGHT, INNER_PAGE_HEIGHT_WHEADER } from '../layout'

export const MainTabsArea = ({ children, canScroll = true }) => {
  return (
    <div
      style={{
        flex: 1,
        overflowY: canScroll ? 'auto' : 'hidden',
        overflowX: 'hidden',
        height: INNER_PAGE_HEIGHT,
      }}
    >
      {children}
    </div>
  )
}

export const MainTabsAreaWithHeader = ({ children, canScroll = true }) => {
  return (
    <div
      style={{
        flex: 1,
        overflowY: canScroll ? 'auto' : 'hidden',
        overflowX: 'hidden',
        height: INNER_PAGE_HEIGHT_WHEADER,
      }}
    >
      {children}
    </div>
  )
}
